import loaderData from '@/assets/animations/logo-loading-simple-data.json'
import { useLottie } from '@/hooks'
import { Container } from './Styles'

const Animation = () => {
  const options = {
    animationData: loaderData,
    loop: true,
    autoplay: true,
    style: {
      height: '40%',
      top: '30%',
      position: 'absolute',
      width: 'auto',
      margin: '0 auto',
      left: '50%',
      transform: 'translate(-50%,0)',
    },
  }

  const { View } = useLottie(options)
  return View
}

interface LoadingSpinnerProps {
  defaultColor?: boolean
}

const LoadingSpinner = ({ defaultColor }: LoadingSpinnerProps) => (
  <Container defaultColor={defaultColor}>
    <Animation></Animation>
  </Container>
)

export default LoadingSpinner
